
import './CSS/App.css';
import './CSS/FontOverrides.css';
import './CSS/Comments.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import CookieConsentBanner from './components/UI/CookieConsentBanner';
import React, { useEffect } from 'react';
import AppRoutes from './Route/AppRoutes';
import { WEBSITE_NAME } from './config/branding';
import { useUserStatus } from './contexts/UserStatusContext';

// Only import and render debug modules when explicitly enabled via env var.
// Using require inside a compile-time condition helps bundlers drop this code.
let DebugUrlProvider = React.Fragment;
let DebugUrlSwitcher = null;
if (process.env.REACT_APP_ENABLE_DEBUG_UI === 'true') {
  // eslint-disable-next-line global-require
  DebugUrlProvider = require('./contexts/DebugUrlContext').DebugUrlProvider;
  // eslint-disable-next-line global-require
  DebugUrlSwitcher = require('./components/Debug/DebugUrlSwitcher').default;
  // eslint-disable-next-line global-require
  require('./Utils/DevApiHelper'); // Load API helper for browser console
}

function App() {
  const isDebugEnabled = process.env.REACT_APP_ENABLE_DEBUG_UI === 'true';
  const { forceSyncSubscriptionStatus, userStatus } = useUserStatus();

  // Ensure the document title is set to ThreadShare
  useEffect(() => {
    if (!document.title || document.title === 'undefined') {
      document.title = WEBSITE_NAME || 'ThreadShare';
    }
  }, []);

  // Sync subscription status with Stripe on every page refresh
  useEffect(() => {
    const syncOnRefresh = async () => {
      // Only sync if user is logged in (has a status)
      if (userStatus) {
        console.log('🔄 [App] Page refreshed, syncing subscription status with Stripe...');
        try {
          await forceSyncSubscriptionStatus();
          console.log('✅ [App] Subscription status synced successfully on refresh');
        } catch (error) {
          console.error('❌ [App] Failed to sync subscription on refresh:', error);
          // Don't block app loading if sync fails
        }
      }
    };

    syncOnRefresh();
  }, []); // Empty dependency array = runs once on mount (page refresh)

  return (
    <DebugUrlProvider>
      <div>
        <CookieConsentBanner />
        <AppRoutes />

        {/* Debug URL Switcher - Only rendered when debug UI is enabled */}
        {isDebugEnabled && DebugUrlSwitcher && (
          <DebugUrlSwitcher position="top-left" />
        )}
      </div>
    </DebugUrlProvider>
  );
}

export default App;
